import type { RouteId } from "@/routing/routes";
import earth2 from "./chapters/earth2.json";
import earth3 from "./chapters/earth3.json";
import field from "./chapters/field.json";
import practice from "./chapters/practice.json";
import sources from "./chapters/sources.json";
import stars from "./chapters/stars.json";
import stellar from "./chapters/stellar.json";
import type { ContentNode } from "@/components/content/ContentNodes";

export type ChapterContent = {
  route: RouteId;
  railEntries: { label: string; anchor: string }[];
  anchors: string[];
  nodes: ContentNode[];
};

export const chapters: Record<RouteId, ChapterContent> = {
  field: field as ChapterContent,
  stellar: stellar as ChapterContent,
  earth2: earth2 as ChapterContent,
  stars: stars as ChapterContent,
  earth3: earth3 as ChapterContent,
  practice: practice as ChapterContent,
  sources: sources as ChapterContent,
};

export function getChapter(route: RouteId): ChapterContent {
  return chapters[route];
}
